import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { IonIcon } from "@ionic/angular";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "app-error-loading-widget",
    templateUrl: "./error-loading-widget.component.html",
    styleUrls: ["./error-loading-widget.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonIcon, TranslatePipe]
})
export class ErrorLoadingWidgetComponent implements OnInit {
    ngOnInit() { }

    ngOnChanges() { }
}
